var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.592,91.8q.345-33.381.688-66.763l.009-.8c.2.217.318.334.427.456q2.421,2.709,4.843,5.419,8.082,9.045,16.165,18.09a5.974,5.974,0,0,0,9.011.341,7.438,7.438,0,0,0,0-9.992q-1.434-1.61-2.872-3.215-14.483-16.2-28.973-32.4A14.825,14.825,0,0,0,41.67.888a3.816,3.816,0,0,0-4.8-.074,16.519,16.519,0,0,0-2.476,2.205Q24.427,13.668,14.5,24.356q-6.27,6.73-12.537,13.463A7.653,7.653,0,0,0,1.1,46.882a5.981,5.981,0,0,0,9.584.866q10.8-11.587,21.591-23.182c.12-.129.245-.25.447-.454l-.007.726-.684,66.344c0,.262-.008.524-.006.786.041,4.439,3.748,7.683,7.672,6.712C42.564,97.972,44.558,95.172,44.592,91.8Z","fill":"#FFFFFF"}));
}

Arrow.defaultProps = {"width":"77.663","height":"98.853","viewBox":"0 0 77.663 98.853"};

module.exports = Arrow;

Arrow.default = Arrow;
